const getPropsFromWindow = function getPropsFromWindowObject(Component, domId) {
  return window.upFreeProducts[domId];
};

export default getPropsFromWindow;
